import type { AtomRow, Force } from '../data/atomizerSamples'

const NEVER_RE = /\b(never|must not|shall not|may not|do not|don['’]t|cannot|can['’]t|prohibited|not permitted|no one may)\b/i
const MUST_RE = /\b(must|shall|required|requires|always|need to|needs to|has to|have to|mandatory)\b/i
const SHOULD_RE = /\b(should|recommended|prefer|preferably|ideally|encouraged)\b/i

function forceOf(sentence: string): Force | null {
  if (NEVER_RE.test(sentence)) return 'NEVER'
  if (MUST_RE.test(sentence)) return 'MUST'
  if (SHOULD_RE.test(sentence)) return 'SHOULD'
  return null
}

function clip(text: string, max: number): string {
  return text.length > max ? `${text.slice(0, max - 1).trimEnd()}…` : text
}

/** A short trigger phrase: the words leading up to the obligation verb. */
function triggerOf(sentence: string): string {
  const lead = sentence.split(/\b(must|shall|should|never|always|may not|do not|cannot|is required)\b/i)[0] ?? ''
  const words = lead.replace(/[^\w\s$%-]/g, '').trim().split(/\s+/).filter(Boolean)
  return words.length ? clip(words.slice(-3).join(' ').toLowerCase(), 24) : 'any request'
}

/**
 * A first-pass reading of pasted text: every sentence that carries obligation
 * language becomes a row. The real Atomizer does far more; this shows the shape.
 */
export function extractRules(text: string, max: number): AtomRow[] {
  const sentences = text
    .replace(/\s+/g, ' ')
    .split(/(?<=[.!?;])\s+|\n+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 12)

  const rows: AtomRow[] = []
  sentences.forEach((s, i) => {
    if (rows.length >= max) return
    const force = forceOf(s)
    if (!force) return
    rows.push({
      force,
      rule: clip(s.replace(/^[-•*\d.)\s]+/, ''), 120),
      trigger: triggerOf(s),
      source: `¶${i + 1}`,
      words: `“${clip(s, 60)}”`,
    })
  })
  return rows
}
